import { AxiosRequestConfig } from 'axios'

export interface FrequencyEvolutionByLevelParams {
  endDate: string
  storeId?: number
  userType?: 'all' | 'recurrent'
}

export interface FrequencyEvolutionByLevelData {
  month: string
  [key: string]: string | number // Dynamic level properties
}

export interface FrequencyEvolutionByLevelResponse {
  data: {
    dates: FrequencyEvolutionByLevelData[]
    levels: Array<{
      name: string
      level: number
    }>
  }
}

export const getFrequencyEvolutionByLevel = (
  params: FrequencyEvolutionByLevelParams,
): AxiosRequestConfig => ({
  url: '/dashboard/frequency-evolution-by-level',
  method: 'GET',
  params,
})
